module.exports = __webpack_public_path__ + "img/IMG_7092.f716f3e0.webp";